import { useMsal } from '@azure/msal-react';
import { Box, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { PORTAL_AUTH_SCOPES } from '@/config';

export const Login = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  const handleLogin = async () => {
    const result = await instance.loginPopup({ 
      scopes: PORTAL_AUTH_SCOPES
    });

    if (result?.accessToken) {
      navigate('/app');
    }
  };

  return (
    <Box minH="100vh" pt="50vh" bgColor="purple" textAlign="center">
      <Button onClick={handleLogin}>Login</Button>
    </Box>
  );
};
